<template>
    <div class="bubble-wrapper" v-if="isMyComponentEnabled">
        <div  class="bubble-container">
            <img  loading="lazy" class="tgpt-icon" src="/images/tgpt/Taia_v3_AuraCustom_full-2.gif" v-if="!showChatPopup" @click.stop="handleClick()" />
            <img class="tgpt-icon" src="/images/tgpt/taia-icon.svg" v-else @click.stop="initializeIframePopup(true)" />
            <div class="bubble-box" v-bind:class="{'isPDP':isProductPage}" v-show="visible && !showChatPopup && pageType != 'navbar'"  :style="boxStyle()">
                <div class="bubble-content">
                    <div v-if="isProductPage">
                        <div class="bubble-header">
                            <h5 class="bubble-text">Do you want to know more about this product?</h5>
                            <div class="bubble-close" @click="hide"></div>
                        </div>
                        <div class="bubble-tags">
                            <div class="bubble-tag" v-for="givenPills in PdpPills" @click="handlePillsClick(givenPills)">{{ givenPills }}</div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="bubble-header plp">
                            <div class="bubble-text">Hi! I'm Taia, your AI Wellness Advisor. I'm created by Thorne's science and medical teams. Ask me about your health goals or Thorne products, and I'll provide you with personalized recommendations.</div>
                            <div class="bubble-close" @click="hide"></div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Cookies from "js-cookie";
import DynamicYieldAbHelper from "../../mixins/dynamicyield-ab-helper";


export default {
	name: "TgptChatIcon",
    mixins: [ DynamicYieldAbHelper ],
    props: {
        pageType: {default: "HomePage"},
    },
    computed:  {
        ...mapState("tgpt",['showChatPopup','minimiseValue','inputSearchQuery']),
        isProductPage() {
            let returnValue = false
            const pdpPage = document.getElementById('pages-product-content')
            if(pdpPage) {
                returnValue = true
            }
            return returnValue
        },
        cutoffPixels() {
            return this.cutoffToPixels(this.mobileCutoff);
        },
        isMobileLayout() {
            return !(this.width >= this.cutoffPixels);
        },
        isMyComponentEnabled() {
            const myVariationData = this.getCustomJSONVariationBySelector(this.tgptAbTestingKey);
            return !!(myVariationData && myVariationData.enabled);
        }
    },
    data() {
        return {
            visible: false,
            autoHiderTimer: null,
            delayTimer:null,
            PdpPills: [
                'Is this product right for me?',
                'What does this product do?',
                'How do I use this product?',
                'More info on ingredients'
            ],
            mobileCutoff: "desktop" ,
            width: window.innerWidth,
            tgptAbTestingKey: tgptAbTestingKey
        }
    },
    methods: {
        ...mapActions("tgpt",[
             "openIframe","updateInputSearchQuery","handleMiniseAndMaxiseEvent","postMessageToIframe"
        ]),
        handleClick() {
          this.initializeIframePopup(true);
          this.handleGA4Event();
        },
        initializeIframePopup(shouldReset = true) {
            this.openIframe()
            if(this.showChatPopup && this.minimiseValue ) {
                this.handleMiniseAndMaxiseEvent(false)
            }
            if(shouldReset) {
                this.updateInputSearchQuery()
            }
        },
        handlePillsClick(givenPills) {
          var screenName = document.title;
          window.dataLayer.push({ "event": "Taia", "button_name": "pdp_flyout", "screen_name": screenName })
            this.updateInputSearchQuery({'query':givenPills,'type': 'flyout'})
            this.initializeIframePopup(false)
            this.postMessageToIframe({
                type:"send_pills",
                data:{ value : givenPills}
			})
        },
      handleGA4Event(){
        var screenName = document.title;
        window.dataLayer.push({ "event": "Taia", "button_name": "click_into_chat_bot", "screen_name": screenName })
      },
        show() {
            this.visible = true;
        },
        hide(event) {
            var screenName = document.title;
            window.dataLayer.push({ "event": "Taia", "button_name": "flyout_dismissal", "screen_name": screenName })
            event.stopPropagation();
            this.visible = false;
            const givenKey = this.isProductPage ? 'pdpTooltipShown' : 'tooltipShown'
            window.sessionStorage.setItem(givenKey,true)
            clearTimeout(this.autoHiderTimer)
        },
        cutoffToPixels(cutoff) {
            const cutoffs = {
                mobile: 0,
                tablet: 769,
                desktop: 1024,
                widescreen: 1216,
                fullhd: 1408,
            };

            if (typeof cutoff === "number") {
                return cutoff;
            } else if (cutoffs[cutoff]) {
                return cutoffs[cutoff];
            } else {
                return cutoffs.desktop;
            }
        },
        boxStyle() {
            let style = {};
            if (this.isMobileLayout) {
                style.width = `${this.width - 50}px`
            }
            return style;
        },
    },
    mounted() {
    if (this.isProductPage) {
        setTimeout(() => {
        const skuParams = Cookies.get('skuParams') || '';
        if (!skuParams) return;
        const pdpShownRaw = window.sessionStorage.getItem('pdpTooltipShown');
        let pdpShownArray = pdpShownRaw ? JSON.parse(pdpShownRaw) : [];
        if (!pdpShownArray.includes(skuParams)) {
            this.delayTimer = setTimeout(() => {
                this.show();
                pdpShownArray.push(skuParams);
                window.sessionStorage.setItem('pdpTooltipShown', JSON.stringify(pdpShownArray));
                this.autoHiderTimer = setTimeout(() => {
                    this.visible = false;
                }, 10000);
            }, 3000);
        }
    },2000)
    } else {
        let hasSeenTooltip = window.sessionStorage.getItem('tooltipShown');
        if (!hasSeenTooltip) {
            this.delayTimer = setTimeout(() => {
                this.show();
                window.sessionStorage.setItem('tooltipShown', 'true');
                this.autoHiderTimer = setTimeout(() => {
                    this.visible = false;
                }, 10000); // hide after 10 seconds
            }, 5000); // wait 5 seconds before showing
        }
    }
}
}
</script>